export default "__VITE_ASSET__b26432f8__"